export default __webpack_public_path__ + "static/media/truck-time.6f6c9b30.svg";